<div class="page-innder-body portlet light">
  <div class="portlet-body">
    <div class="container">
      <div class="dsRow">
        <div class="dsLogoContainer">
          <img src="assets/images/thumb_AFP-logo-v02-noTagline-800.png" alt="">
        </div>
        <div class="dsWelcomeDiv">
          <h1>{{ 'acceptInvitation.invitedTitle' | transloco }}</h1>
          <p class="dsIntro">{{ 'acceptInvitation.intro' | transloco }}</p>
          <p class="dsEmphasis">{{ 'acceptInvitation.learnMorePrefix' | transloco }} <a href="#features">{{ 'acceptInvitation.below' | transloco }}</a>{{ 'acceptInvitation.learnMoreMiddle' | transloco }} <a
        href="https://artflow-pro.com" target="_blank">{{ 'acceptInvitation.website' | transloco }}</a> {{ 'acceptInvitation.learnMoreOr' | transloco }} <span
      class="dsOpenVideo dsLink">{{ 'acceptInvitation.video' | transloco }}</span>
    </p>
    <div class="mt-5">
      <p class="dsBold">{{ 'acceptInvitation.gettingStarted' | transloco }}</p>
      <p>{{ 'acceptInvitation.signupHint' | transloco }}</p>
    </div>
  </div>
  <form class="col-9 p-4" #form="ngForm"
    style="background-color: white;   font-size: 0.9rem;  border: 1px solid #aaa;  border-radius: 6px;padding: 20px; box-shadow: 0 0 20px rgba(0, 0, 0, 0.1)">
    <!-- Full Name -->
    <div class="row mb-3">
      <div class="col-md-6">
        <label for="FirstName" class="form-label">
          <span class="text-danger">*</span> {{ 'acceptInvitation.firstName' | transloco }}
        </label>
        <input type="text" id="FirstName" [(ngModel)]="signupForm.FirstName" class="form-control"
          [placeholder]="'acceptInvitation.firstName' | transloco" name="FirstName" required>
        </div>
        <div class="col-md-6">
          <label for="LastName" class="form-label">
            <span class="text-danger">*</span> {{ 'acceptInvitation.lastName' | transloco }}
          </label>
          <input type="text" id="LastName" [(ngModel)]="signupForm.LastName" class="form-control"
            [placeholder]="'acceptInvitation.lastName' | transloco" name="LastName" required>
          </div>
        </div>

        <!-- Email and Phone -->
        <div class="row mb-3">
          <div class="col-md-8">
            <label for="EmailAddress" class="form-label">
              <span class="text-danger">*</span> {{ 'acceptInvitation.emailAddress' | transloco }}
            </label>
            <input type="email" id="EmailAddress" [(ngModel)]="signupForm.Email" class="form-control"
              [placeholder]="'acceptInvitation.emailAddress' | transloco" name="email" required>
            </div>
            <div class="col-md-4">
              <label for="PhoneNumber" class="form-label">{{ 'acceptInvitation.phoneNumber' | transloco }}</label>
              <input type="tel" id="PhoneNumber" [(ngModel)]="signupForm.PhoneNumber" class="form-control"
                [placeholder]="'acceptInvitation.phoneNumber' | transloco" name="PhoneNumber">
              </div>
            </div>

            <!-- Password Fields -->
            <div class="row mb-3">
              <div class="col-md-6">
                <label for="Password" class="form-label">
                  <span class="text-danger">*</span> {{ 'acceptInvitation.password' | transloco }}
                </label>
                <input type="password" id="Password" [(ngModel)]="signupForm.Password" class="form-control"
                  [placeholder]="'acceptInvitation.password' | transloco" name="Password" required>
                </div>
                <div class="col-md-6">
                  <label for="ConfirmPassword" class="form-label">
                    <span class="text-danger">*</span> {{ 'acceptInvitation.confirmPassword' | transloco }}
                  </label>
                  <input type="password" id="ConfirmPassword" [(ngModel)]="signupForm.ConfirmPassword" class="form-control"
                    [placeholder]="'acceptInvitation.confirmPassword' | transloco" name="ConfirmPassword" required>
                    @if (isPasswordMismatch()) {
                      <div class="text-danger mt-1">{{ 'acceptInvitation.passwordsMismatch' | transloco }}</div>
                    }
                  </div>
                </div>

                <!-- Business Name (Artist) -->
                @if (signupForm.AccountType === 'Artist') {
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label for="BusinessName" class="form-label">{{ 'acceptInvitation.businessName' | transloco }}</label>
                      <input type="text" id="BusinessName" [(ngModel)]="signupForm.BusinessName" class="form-control"
                        [placeholder]="'acceptInvitation.businessName' | transloco" name="BusinessName">
                      </div>
                    </div>
                  }

                  <!-- Account Type -->
                  <div class="row mb-4">
                    <div class="col-12">
                      <h4 class="dsH4">{{ 'acceptInvitation.accountType' | transloco }} <span class="text-danger">*</span></h4>
                      <p class="dsText">{{ 'acceptInvitation.accountTypeHint' | transloco }}</p>
                    </div>
                    <div class="col-md-6">
                      <div class="form-check">
                        <input class="form-check-input dsRadio" type="radio" name="AccountType" id="AccountTypeArtist"
                          value="Artist" [(ngModel)]="signupForm.AccountType">
                          <label class="form-check-label" for="AccountTypeArtist">{{ 'acceptInvitation.freeArtistAccount' | transloco }}</label>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-check">
                          <input class="form-check-input dsRadio" type="radio" name="AccountType" id="AccountTypeGallery"
                            value="Gallery" [(ngModel)]="signupForm.AccountType">
                            <label class="form-check-label" for="AccountTypeGallery">{{ 'acceptInvitation.freeGalleryAccount' | transloco }}</label>
                          </div>
                        </div>
                      </div>

                      <!-- Gallery Name -->
                      @if (signupForm.AccountType === 'Gallery') {
                        <div class="row mb-3">
                          <div class="col-md-6">
                            <label for="GalleryName" class="form-label">
                              <span class="text-danger">*</span> {{ 'acceptInvitation.galleryName' | transloco }}
                            </label>
                            <input type="text" id="GalleryName" [(ngModel)]="signupForm.BusinessName" class="form-control"
                              [placeholder]="'acceptInvitation.galleryName' | transloco" name="businessName" required>
                            </div>
                          </div>
                        }

                        <!-- Artwork Type -->
                        @if (signupForm.AccountType === 'Artist') {
                          <div class="row mb-3">
                            <div class="col-md-6">
                              <label for="artType" class="form-label">
                                <span class="text-danger">*</span> {{ 'acceptInvitation.artworkType' | transloco }}
                              </label>
                              <select class="form-select" name="artType" [(ngModel)]="signupForm.PrimaryArtTypeId">
                                <option value="" disabled selected>{{ 'acceptInvitation.selectArtworkType' | transloco }}</option>
                                @for (artType of artTypes; track artType) {
                                  <option [value]="artType.Id">{{ artType.Name }}</option>
                                }
                              </select>
                            </div>
                          </div>
                        }

                        <!-- Find Artists/Galleries Checkbox -->
                        @if (signupForm.AccountType) {
                          <div class="form-check mb-4">
                            <input class="form-check-input" type="checkbox" [(ngModel)]="showAdditionalInfo" name="p-checkbox"
                              id="binary">
                              <label class="form-check-label" for="binary">{{ 'acceptInvitation.findNearYou' | transloco }}</label>
                            </div>
                          }

                          <!-- Additional Information -->
                          @if (showAdditionalInfo) {
                            <div>
                              <div class="row mb-3">
                                <div class="col-md-6">
                                  <label for="Country" class="form-label">
                                    <span class="text-danger">*</span> {{ 'acceptInvitation.country' | transloco }}
                                  </label>
                                  <select id="Country" class="form-select" [(ngModel)]="selectedCountryId"
                                    (change)="onCountryChange($event)" name="Country">
                                    <option value="">{{ 'acceptInvitation.selectCountry' | transloco }}</option>
                                    @for (country of countries; track country) {
                                      <option [value]="country.id">{{ country.name }}</option>
                                    }
                                  </select>
                                </div>
                                <div class="col-md-6">
                                  <label for="State" class="form-label">
                                    <span class="text-danger">*</span> {{ 'acceptInvitation.state' | transloco }}
                                  </label>
                                  <select id="State" class="form-select" [(ngModel)]="selectedStateId" [disabled]="!selectedCountryId"
                                    (change)="onStateChange($event)" name="State">
                                    <option value="">{{ 'acceptInvitation.selectState' | transloco }}</option>
                                    @for (state of states; track state) {
                                      <option [value]="state.id">{{ state.name }}</option>
                                    }
                                  </select>
                                </div>
                              </div>
                              <div class="row mb-3">
                                <div class="col-md-8">
                                  <label for="City" class="form-label">{{ 'acceptInvitation.city' | transloco }}</label>
                                  <select id="City" class="form-select" [(ngModel)]="selectedCityId" [disabled]="!selectedStateId"
                                    (change)="onCityChange($event)" name="City">
                                    <option value="">{{ 'acceptInvitation.selectCity' | transloco }}</option>
                                    @for (city of cities; track city) {
                                      <option [value]="city.id">{{ city.name }}</option>
                                    }
                                  </select>
                                </div>
                                <div class="col-md-4">
                                  <label for="Zip" class="form-label">{{ 'acceptInvitation.postCode' | transloco }}</label>
                                  <input type="text" id="Zip" [(ngModel)]="signupForm.Zip" class="form-control" name="Zip"
                                    [placeholder]="'acceptInvitation.zip' | transloco">
                                  </div>
                                </div>
                                <div class="row mb-3">
                                  <div class="col-12">
                                    <label for="Address1" class="form-label">{{ 'acceptInvitation.address1' | transloco }}</label>
                                    <input type="text" id="Address1" [(ngModel)]="signupForm.AddressLine1" class="form-control"
                                      [placeholder]="'acceptInvitation.address1Placeholder' | transloco" name="Address1">
                                    </div>
                                  </div>
                                  <div class="row mb-3">
                                    <div class="col-12">
                                      <label for="Address2" class="form-label">{{ 'acceptInvitation.address2' | transloco }}</label>
                                      <input type="text" id="Address2" [(ngModel)]="signupForm.AddressLine2" class="form-control"
                                        [placeholder]="'acceptInvitation.address2Placeholder' | transloco" name="Address2">
                                      </div>
                                    </div>
                                  </div>
                                }

                                <!-- Submit Button -->
                                <div class="row">
                                  <div class="dsRequired mt-3">{{ 'acceptInvitation.requiredFields' | transloco }}</div>

                                  <div class="col-12 text-end">
              <button type="button" class="btn btn-primary" (click)="signUp()" [disabled]="(!signupForm.FirstName || !signupForm.Email || !signupForm.Password || 
                (signupForm.AccountType === 'Artist' ? (!signupForm.PrimaryArtTypeId) : !signupForm.BusinessName) || 
                (showAdditionalInfo && (!selectedCountryId || !selectedStateId)))">
                                      {{ 'acceptInvitation.createFreeAccount' | transloco }}
                                    </button>
                                  </div>
                                </div>


                              </form>

                              <div id="features" class="dsArtflowInfo">
                                <h2>{{ 'acceptInvitation.shareTitle' | transloco }}</h2>
                                <p class="dsEmphasis">
                                  {{ 'acceptInvitation.shareIntro' | transloco }}
                                </p>

                                <div class="dsAFPfeatures">
                                  <div class="dsBullets">
                                    <div class="dsIcon">
                                      <img src="assets\images\AFP-logo-tik.png" alt="">
                                    </div>
                                    <div class="dsText">
                                      <b>{{ 'acceptInvitation.oneUploadTitle' | transloco }}</b> {{ 'acceptInvitation.oneUploadDesc' | transloco }}
                                    </div>
                                  </div>
                                  <div class="dsBullets">
                                    <div class="dsIcon">
                                      <img src="assets\images\AFP-logo-tik.png" alt="">
                                    </div>
                                    <div class="dsText">
                                      <b>{{ 'acceptInvitation.consignmentTitle' | transloco }}</b> {{ 'acceptInvitation.consignmentDesc' | transloco }}
                                    </div>
                                  </div>
                                  <div class="dsBullets">
                                    <div class="dsIcon">
                                      <img src="assets\images\AFP-logo-tik.png" alt="">
                                    </div>
                                    <div class="dsText">
                                      <b>{{ 'acceptInvitation.streamlinedTitle' | transloco }}</b> {{ 'acceptInvitation.streamlinedDesc' | transloco }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="dsArtflowInfo">
                                <h2>{{ 'acceptInvitation.boostTitle' | transloco }}</h2>
                                <div class="dsAFPfeatures">
                                  <div class="dsBullets">
                                    <div class="dsIcon">
                                      <img src="assets\images\AFP-logo-tik.png" alt="">
                                    </div>
                                    <div class="dsText">
                                      <b>{{ 'acceptInvitation.professionalDocTitle' | transloco }}</b> {{ 'acceptInvitation.professionalDocDesc' | transloco }}
                                    </div>
                                  </div>
                                  <div class="dsBullets">
                                    <div class="dsIcon">
                                      <img src="assets\images\AFP-logo-tik.png" alt="">
                                    </div>
                                    <div class="dsText">
                                      <b>{{ 'acceptInvitation.accurateDataTitle' | transloco }}</b> {{ 'acceptInvitation.accurateDataDesc' | transloco }}
                                    </div>
                                  </div>
                                  <div class="dsBullets">
                                    <div class="dsIcon">
                                      <img src="assets\images\AFP-logo-tik.png" alt="">
                                    </div>
                                    <div class="dsText">
                                      <b>{{ 'acceptInvitation.enhancedRepTitle' | transloco }}</b> {{ 'acceptInvitation.enhancedRepDesc' | transloco }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="dsArtflowInfo">
                                <h2>{{ 'acceptInvitation.easyTitle' | transloco }}</h2>
                                <div class="dsAFPfeatures">
                                  <!-- Removed empty bullet -->
                                  <div class="dsBullets">
                                    <div class="dsIcon">
                                      <img src="assets\images\AFP-logo-tik.png" alt="">
                                    </div>
                                    <div class="dsText">
                                      <b>{{ 'acceptInvitation.noLockInsTitle' | transloco }}</b> {{ 'acceptInvitation.noLockInsDesc' | transloco }}
                                    </div>
                                  </div>
                                  <div class="dsBullets">
                                    <div class="dsIcon">
                                      <img src="assets\images\AFP-logo-tik.png" alt="">
                                    </div>
                                    <div class="dsText">
                                      <b>{{ 'acceptInvitation.noHiddenCostsTitle' | transloco }}</b> {{ 'acceptInvitation.noHiddenCostsDesc' | transloco }}
                                    </div>
                                  </div>
                                  <div class="dsBullets">
                                    <div class="dsIcon">
                                      <img src="assets\images\AFP-logo-tik.png" alt="">
                                    </div>
                                    <div class="dsText">
                                      <b>{{ 'acceptInvitation.safeSecureTitle' | transloco }}</b> {{ 'acceptInvitation.safeSecureDesc' | transloco }}
                                    </div>
                                  </div>
                                  <div class="dsBullets">
                                    <div class="dsIcon">
                                      <img src="assets\images\AFP-logo-tik.png" alt="">
                                    </div>
                                    <div class="dsText">
                                      <b>{{ 'acceptInvitation.autoNotifTitle' | transloco }}</b> {{ 'acceptInvitation.autoNotifDesc' | transloco }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="dsArtflowInfo">
                                <h2>{{ 'acceptInvitation.onboardingTitle' | transloco }}</h2>
                                <p class="dsEmphasis">{{ 'acceptInvitation.newToArtflow' | transloco }}</p>
                                <p style="font-weight: 500;">
                                  {{ 'acceptInvitation.onboardingIntro' | transloco }}
                                </p>
                                <div class="dsAFPfeatures">
                                  <div class="dsBullets">
                                    <div class="dsIcon">
                                      <img src="assets\images\AFP-logo-tik.png" alt="">
                                    </div>
                                    <div class="dsText">{{ 'acceptInvitation.uploadArtworks' | transloco }}</div>
                                  </div>
                                  <div class="dsBullets">
                                    <div class="dsIcon">
                                      <img src="assets\images\AFP-logo-tik.png" alt="">
                                    </div>
                                    <div class="dsText">{{ 'acceptInvitation.manageConsignment' | transloco }}</div>
                                  </div>
                                  <div class="dsBullets">
                                    <div class="dsIcon">
                                      <img src="assets\images\AFP-logo-tik.png" alt="">
                                    </div>
                                    <div class="dsText">{{ 'acceptInvitation.sharePortfolios' | transloco }}</div>
                                  </div>
                                </div>
                              </div>
                              <div class="dsArtflowInfo">
                                <h2>{{ 'acceptInvitation.needMoreTitle' | transloco }}</h2>
                                <p style="font-weight: 400;">
                                  <b>{{ 'acceptInvitation.goPro' | transloco }}</b> {{ 'acceptInvitation.goProDesc' | transloco }}
                                </p>
                                <p>
                                  <!-- Find out more about Artflow Pro pricing <a href="https://artflow-pro.com/#dsPricing" target="_parent">here.</a> -->
                                </p>
                              </div>
                              <div class="dsVideoPlayerDiv clearfix">
                                <h4>{{ 'acceptInvitation.videoOfferQuestion' | transloco }}<br /> {{ 'acceptInvitation.checkOutVideo' | transloco }}</h4>
                                <button class="dsOpenVideo btn btn-outline-secondary"
                                  link="https://artflow-pro.com/video/artflow-pro-promo.mp4">
                                  {{ 'acceptInvitation.playVideo' | transloco }}
                                </button>
                              </div>
                            </div>
                          </div>
                          <div id="afpVideo" class="dsVideoContainer">
                            <div class="dsCloseVideo">X</div>
                          </div>
                          <div class="dsFooter"></div>
                        </div>
                      </div>